/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */
   
import TermsAndConditions from "./TermsAndConditions";

export default TermsAndConditions;
